import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import { BehaviourField } from '@/configuration/BehaviourField';
import { FieldType } from '@/configuration/FieldType';
import { VerbatimField } from '@/configuration/VerbatimField';
import { behaviours } from '@/configuration/behaviours';
import { verbatims } from '@/configuration/verbatims';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    behaviours,
    verbatims,
    params: 'Init',
    response: {
      currentStep: 1,
    },
    surveyFlow: {
      self: [
        'Intro',
        {
          title: '<u>Behaviors</u> (Values)',
          fields: [
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Generosity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Passion,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Solidarity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Curiosity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Boldness,
            },
            {
              type: FieldType.Verbatim,
              field: VerbatimField.Bhv_Improvement_RoleModel,
            },
            {
              type: FieldType.Verbatim,
              field: VerbatimField.Bhv_Improvement_SeeMore,
            },
          ],
        },
        'Summary',
        'SurveyEnd',
      ],
      peer: [
        'Intro',
        {
          title: '<u>Behaviors</u> (Values)',
          fields: [
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Generosity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Passion,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Solidarity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Curiosity,
            },
            {
              type: FieldType.Behaviour,
              field: BehaviourField.Bhv_Boldness,
            },
            {
              type: FieldType.Verbatim,
              field: VerbatimField.Bhv_Improvement_RoleModel,
            },
            {
              type: FieldType.Verbatim,
              field: VerbatimField.Bhv_Improvement_SeeMore,
            },
          ],
        },
        'Improvement',
        'Summary',
        'SurveyEnd',
      ],
    },
    optout: {
      field: 'Optout_Reason',
      title: 'Decline Request',
      question: 'Please provide your reason for declining the request for feedback',
      options: [
        'Lack of relevant exposure',
        'Feedback provided through different channel',
        'Other',
      ],
      verbatim: {
        field: 'Optout_Reason_Other',
        question: 'Please specify',
      },
    },
  },
  mutations: {
    storeResponse(state, r) {
      state.response[r.k] = r.v;
    },
    setParams(state, paramsFromContext) {
      state.params = paramsFromContext;
    },
    setCurrentStep(state, r) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.currentStep = r;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.currentStep = r;
    },
    incrementCurrentStep(state) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.currentStep += 1;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.currentStep += 1;
    },
    completeSurvey(state) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.isCompleted = true;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.isCompleted = true;
    },
    previousPage(state, stepNumber) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.currentStep = stepNumber;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.currentStep = stepNumber;
    },
  },
  actions: {
    storeResponse({ state }) {
      axios.post('api/response/store', state.responseCommited);
    },
  },
  getters: {
    currentStep(state) {
      return state.response.currentStep;
    },
    isSelfSurvey(state) {
      if (state.params.SurveyType) {
        return state.params.SurveyType.toLowerCase() === 'self';
      }
      return false;
    },
    surveyFlow(state) {
      return state.surveyFlow[state.params.SurveyType.toLowerCase()];
    },
    isOptedOut(state) {
      return state.response.IsOptedOut;
    },
  },
});
